// Code generated by @hex-insights/frontend-generator; While this comment is present this file may be overwritten. If manual edits are made, remove this comment.
import { IndexForms } from "@hex-insights/app-modules";
import { CaseStyle, convertCase } from "@hex-insights/core";
import { FieldInputOption } from "@hex-insights/forms";
import { OrderDirection, StudentBehaviorNote, StudentBehaviorNoteOrderField } from "../../../Utilities";

export type OrderFormValues = IndexForms.OrderFormValues<StudentBehaviorNoteOrderField | null>;

export const initial: OrderFormValues = {
	field: StudentBehaviorNoteOrderField.IncidentTime,
	direction: OrderDirection.Desc,
};

export function getInitial(initialFormValues?: Partial<OrderFormValues>) {
	return { ...initial, ...initialFormValues };
}

/**
 * Options for the "field" field in the order form of the StudentBehaviorNote model.
 */
export const fieldOptions: FieldInputOption<StudentBehaviorNoteOrderField | null>[] = [
	{ label: "ID", value: null },
	{
		label: convertCase(StudentBehaviorNoteOrderField.IncidentTime.toLowerCase(), CaseStyle.Title),
		value: StudentBehaviorNoteOrderField.IncidentTime,
	},
	{
		label: convertCase(StudentBehaviorNoteOrderField.IncidentLocation.toLowerCase(), CaseStyle.Title),
		value: StudentBehaviorNoteOrderField.IncidentLocation,
	},
	{
		label: convertCase(
			StudentBehaviorNoteOrderField.IsIncidentPhysicalContactAggression.toLowerCase(),
			CaseStyle.Title,
		),
		value: StudentBehaviorNoteOrderField.IsIncidentPhysicalContactAggression,
	},
	{
		label: convertCase(
			StudentBehaviorNoteOrderField.IsIncidentFightingPhysicalAggression.toLowerCase(),
			CaseStyle.Title,
		),
		value: StudentBehaviorNoteOrderField.IsIncidentFightingPhysicalAggression,
	},
	{
		label: convertCase(
			StudentBehaviorNoteOrderField.IsIncidentVerbalAbuseDisrespectingStudent.toLowerCase(),
			CaseStyle.Title,
		),
		value: StudentBehaviorNoteOrderField.IsIncidentVerbalAbuseDisrespectingStudent,
	},
	{
		label: convertCase(StudentBehaviorNoteOrderField.IsIncidentDisrepectingTeacher.toLowerCase(), CaseStyle.Title),
		value: StudentBehaviorNoteOrderField.IsIncidentDisrepectingTeacher,
	},
	{
		label: convertCase(StudentBehaviorNoteOrderField.IsIncidentDisruption.toLowerCase(), CaseStyle.Title),
		value: StudentBehaviorNoteOrderField.IsIncidentDisruption,
	},
	{
		label: convertCase(StudentBehaviorNoteOrderField.IsIncidentDefianceOrNonCompliance.toLowerCase(), CaseStyle.Title),
		value: StudentBehaviorNoteOrderField.IsIncidentDefianceOrNonCompliance,
	},
	{
		label: convertCase(StudentBehaviorNoteOrderField.IsIncidentOther.toLowerCase(), CaseStyle.Title),
		value: StudentBehaviorNoteOrderField.IsIncidentOther,
	},
	{
		label: convertCase(StudentBehaviorNoteOrderField.IsMotivationAttentionSeeking.toLowerCase(), CaseStyle.Title),
		value: StudentBehaviorNoteOrderField.IsMotivationAttentionSeeking,
	},
	{
		label: convertCase(StudentBehaviorNoteOrderField.IsMotivationReaction.toLowerCase(), CaseStyle.Title),
		value: StudentBehaviorNoteOrderField.IsMotivationReaction,
	},
	{
		label: convertCase(StudentBehaviorNoteOrderField.IsMotivationAnger.toLowerCase(), CaseStyle.Title),
		value: StudentBehaviorNoteOrderField.IsMotivationAnger,
	},
	{
		label: convertCase(StudentBehaviorNoteOrderField.IsMotivationFrustration.toLowerCase(), CaseStyle.Title),
		value: StudentBehaviorNoteOrderField.IsMotivationFrustration,
	},
	{
		label: convertCase(StudentBehaviorNoteOrderField.IsMotivationHabit.toLowerCase(), CaseStyle.Title),
		value: StudentBehaviorNoteOrderField.IsMotivationHabit,
	},
	{
		label: convertCase(StudentBehaviorNoteOrderField.IsMotivationLackOfSelfContol.toLowerCase(), CaseStyle.Title),
		value: StudentBehaviorNoteOrderField.IsMotivationLackOfSelfContol,
	},
	{
		label: convertCase(StudentBehaviorNoteOrderField.IsMotivationOther.toLowerCase(), CaseStyle.Title),
		value: StudentBehaviorNoteOrderField.IsMotivationOther,
	},
	{
		label: convertCase(
			StudentBehaviorNoteOrderField.IsConsequenceRecDirectorIntervention.toLowerCase(),
			CaseStyle.Title,
		),
		value: StudentBehaviorNoteOrderField.IsConsequenceRecDirectorIntervention,
	},
	{
		label: convertCase(
			StudentBehaviorNoteOrderField.IsConsequenceRecSenOrSelIntervention.toLowerCase(),
			CaseStyle.Title,
		),
		value: StudentBehaviorNoteOrderField.IsConsequenceRecSenOrSelIntervention,
	},
	{
		label: convertCase(
			StudentBehaviorNoteOrderField.IsConsequenceRecStudentServiceTeamIntervention.toLowerCase(),
			CaseStyle.Title,
		),
		value: StudentBehaviorNoteOrderField.IsConsequenceRecStudentServiceTeamIntervention,
	},
	{
		label: convertCase(
			StudentBehaviorNoteOrderField.IsConsequenceRecParentContactFromReporter.toLowerCase(),
			CaseStyle.Title,
		),
		value: StudentBehaviorNoteOrderField.IsConsequenceRecParentContactFromReporter,
	},
	{
		label: convertCase(
			StudentBehaviorNoteOrderField.IsConsequenceRecParentContactFromSchoolDirector.toLowerCase(),
			CaseStyle.Title,
		),
		value: StudentBehaviorNoteOrderField.IsConsequenceRecParentContactFromSchoolDirector,
	},
	{
		label: convertCase(StudentBehaviorNoteOrderField.IsConsequenceRecOther.toLowerCase(), CaseStyle.Title),
		value: StudentBehaviorNoteOrderField.IsConsequenceRecOther,
	},
];

/**
 * Array of values for the "field" field in the order form of the StudentBehaviorNote model.
 */
export const fieldValues = fieldOptions.map((e) => e.value);

/**
 * Mapping from order fields of the StudentBehaviorNote model to their corresponding order type.
 */
export const fieldTypeMapping: IndexForms.OrderFieldTypeMapping<StudentBehaviorNoteOrderField> = {
	[StudentBehaviorNoteOrderField.IncidentTime]: IndexForms.OrderFieldType.Time,
	[StudentBehaviorNoteOrderField.IncidentLocation]: IndexForms.OrderFieldType.String,
	[StudentBehaviorNoteOrderField.IsIncidentPhysicalContactAggression]: IndexForms.OrderFieldType.Boolean,
	[StudentBehaviorNoteOrderField.IsIncidentFightingPhysicalAggression]: IndexForms.OrderFieldType.Boolean,
	[StudentBehaviorNoteOrderField.IsIncidentVerbalAbuseDisrespectingStudent]: IndexForms.OrderFieldType.Boolean,
	[StudentBehaviorNoteOrderField.IsIncidentDisrepectingTeacher]: IndexForms.OrderFieldType.Boolean,
	[StudentBehaviorNoteOrderField.IsIncidentDisruption]: IndexForms.OrderFieldType.Boolean,
	[StudentBehaviorNoteOrderField.IsIncidentDefianceOrNonCompliance]: IndexForms.OrderFieldType.Boolean,
	[StudentBehaviorNoteOrderField.IsIncidentOther]: IndexForms.OrderFieldType.Boolean,
	[StudentBehaviorNoteOrderField.IsMotivationAttentionSeeking]: IndexForms.OrderFieldType.Boolean,
	[StudentBehaviorNoteOrderField.IsMotivationReaction]: IndexForms.OrderFieldType.Boolean,
	[StudentBehaviorNoteOrderField.IsMotivationAnger]: IndexForms.OrderFieldType.Boolean,
	[StudentBehaviorNoteOrderField.IsMotivationFrustration]: IndexForms.OrderFieldType.Boolean,
	[StudentBehaviorNoteOrderField.IsMotivationHabit]: IndexForms.OrderFieldType.Boolean,
	[StudentBehaviorNoteOrderField.IsMotivationLackOfSelfContol]: IndexForms.OrderFieldType.Boolean,
	[StudentBehaviorNoteOrderField.IsMotivationOther]: IndexForms.OrderFieldType.Boolean,
	[StudentBehaviorNoteOrderField.IsConsequenceRecDirectorIntervention]: IndexForms.OrderFieldType.Boolean,
	[StudentBehaviorNoteOrderField.IsConsequenceRecSenOrSelIntervention]: IndexForms.OrderFieldType.Boolean,
	[StudentBehaviorNoteOrderField.IsConsequenceRecStudentServiceTeamIntervention]: IndexForms.OrderFieldType.Boolean,
	[StudentBehaviorNoteOrderField.IsConsequenceRecParentContactFromReporter]: IndexForms.OrderFieldType.Boolean,
	[StudentBehaviorNoteOrderField.IsConsequenceRecParentContactFromSchoolDirector]: IndexForms.OrderFieldType.Boolean,
	[StudentBehaviorNoteOrderField.IsConsequenceRecOther]: IndexForms.OrderFieldType.Boolean,
};

/**
 * Mapping from order fields of the StudentBehaviorNote model to their corresponding field name.
 */
export const orderFieldToModelField: Record<StudentBehaviorNoteOrderField, keyof StudentBehaviorNote> = {
	[StudentBehaviorNoteOrderField.IncidentTime]: "incidentTime",
	[StudentBehaviorNoteOrderField.IncidentLocation]: "incidentLocation",
	[StudentBehaviorNoteOrderField.IsIncidentPhysicalContactAggression]: "isIncidentPhysicalContactAggression",
	[StudentBehaviorNoteOrderField.IsIncidentFightingPhysicalAggression]: "isIncidentFightingPhysicalAggression",
	[StudentBehaviorNoteOrderField.IsIncidentVerbalAbuseDisrespectingStudent]:
		"isIncidentVerbalAbuseDisrespectingStudent",
	[StudentBehaviorNoteOrderField.IsIncidentDisrepectingTeacher]: "isIncidentDisrepectingTeacher",
	[StudentBehaviorNoteOrderField.IsIncidentDisruption]: "isIncidentDisruption",
	[StudentBehaviorNoteOrderField.IsIncidentDefianceOrNonCompliance]: "isIncidentDefianceOrNonCompliance",
	[StudentBehaviorNoteOrderField.IsIncidentOther]: "isIncidentOther",
	[StudentBehaviorNoteOrderField.IsMotivationAttentionSeeking]: "isMotivationAttentionSeeking",
	[StudentBehaviorNoteOrderField.IsMotivationReaction]: "isMotivationReaction",
	[StudentBehaviorNoteOrderField.IsMotivationAnger]: "isMotivationAnger",
	[StudentBehaviorNoteOrderField.IsMotivationFrustration]: "isMotivationFrustration",
	[StudentBehaviorNoteOrderField.IsMotivationHabit]: "isMotivationHabit",
	[StudentBehaviorNoteOrderField.IsMotivationLackOfSelfContol]: "isMotivationLackOfSelfContol",
	[StudentBehaviorNoteOrderField.IsMotivationOther]: "isMotivationOther",
	[StudentBehaviorNoteOrderField.IsConsequenceRecDirectorIntervention]: "isConsequenceRecDirectorIntervention",
	[StudentBehaviorNoteOrderField.IsConsequenceRecSenOrSelIntervention]: "isConsequenceRecSenOrSelIntervention",
	[StudentBehaviorNoteOrderField.IsConsequenceRecStudentServiceTeamIntervention]:
		"isConsequenceRecStudentServiceTeamIntervention",
	[StudentBehaviorNoteOrderField.IsConsequenceRecParentContactFromReporter]:
		"isConsequenceRecParentContactFromReporter",
	[StudentBehaviorNoteOrderField.IsConsequenceRecParentContactFromSchoolDirector]:
		"isConsequenceRecParentContactFromSchoolDirector",
	[StudentBehaviorNoteOrderField.IsConsequenceRecOther]: "isConsequenceRecOther",
};

/**
 * Mapping from field names of the StudentBehaviorNote model to their corresponding order field.
 */
export const modelFieldToOrderField: Record<string, StudentBehaviorNoteOrderField> = {
	incidentTime: StudentBehaviorNoteOrderField.IncidentTime,
	incidentLocation: StudentBehaviorNoteOrderField.IncidentLocation,
	isIncidentPhysicalContactAggression: StudentBehaviorNoteOrderField.IsIncidentPhysicalContactAggression,
	isIncidentFightingPhysicalAggression: StudentBehaviorNoteOrderField.IsIncidentFightingPhysicalAggression,
	isIncidentVerbalAbuseDisrespectingStudent: StudentBehaviorNoteOrderField.IsIncidentVerbalAbuseDisrespectingStudent,
	isIncidentDisrepectingTeacher: StudentBehaviorNoteOrderField.IsIncidentDisrepectingTeacher,
	isIncidentDisruption: StudentBehaviorNoteOrderField.IsIncidentDisruption,
	isIncidentDefianceOrNonCompliance: StudentBehaviorNoteOrderField.IsIncidentDefianceOrNonCompliance,
	isIncidentOther: StudentBehaviorNoteOrderField.IsIncidentOther,
	isMotivationAttentionSeeking: StudentBehaviorNoteOrderField.IsMotivationAttentionSeeking,
	isMotivationReaction: StudentBehaviorNoteOrderField.IsMotivationReaction,
	isMotivationAnger: StudentBehaviorNoteOrderField.IsMotivationAnger,
	isMotivationFrustration: StudentBehaviorNoteOrderField.IsMotivationFrustration,
	isMotivationHabit: StudentBehaviorNoteOrderField.IsMotivationHabit,
	isMotivationLackOfSelfContol: StudentBehaviorNoteOrderField.IsMotivationLackOfSelfContol,
	isMotivationOther: StudentBehaviorNoteOrderField.IsMotivationOther,
	isConsequenceRecDirectorIntervention: StudentBehaviorNoteOrderField.IsConsequenceRecDirectorIntervention,
	isConsequenceRecSenOrSelIntervention: StudentBehaviorNoteOrderField.IsConsequenceRecSenOrSelIntervention,
	isConsequenceRecStudentServiceTeamIntervention:
		StudentBehaviorNoteOrderField.IsConsequenceRecStudentServiceTeamIntervention,
	isConsequenceRecParentContactFromReporter: StudentBehaviorNoteOrderField.IsConsequenceRecParentContactFromReporter,
	isConsequenceRecParentContactFromSchoolDirector:
		StudentBehaviorNoteOrderField.IsConsequenceRecParentContactFromSchoolDirector,
	isConsequenceRecOther: StudentBehaviorNoteOrderField.IsConsequenceRecOther,
};
